<template>
    <md-card>
        <headful
			:title="'Caseen User - ' + userStats.uname"
		/>
        <br>
        <h2>User Stats</h2>
        <svg width="100" height="100" :data-jdenticon-value="publicID" style="border: 2px solid #555;"></svg>
        <br>
        <b>{{userStats.uname}}#{{publicID.slice(0, 5)}}</b>
        <table v-if="Object.keys(userStats).length > 0">
            <tr><td colspan="2"></td></tr>
            <tr>
                <td colspan="2">
                    <b><u>Learner Score</u>:</b>
                    <br>
                    {{userStats.learnerScore}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Cases Completed:</b>
                    <br>
                    {{userStats.casesCompleted}}
                </td>
                <td>
                    <b>Cases Reviewed:</b>
                    <br>
                    {{userStats.casesReviewed}}
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    <b><u>Author Score</u>:</b>
                    <br>
                    {{userStats.authorScore}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Cases Owned:</b>
                    <br>
                    {{userStats.casesOwned}}
                </td>
                <td>
                    <b>Cases Collaborated:</b>
                    <br>
                    {{userStats.casesCollaborated}}
                </td>
            </tr>
            <tr>
                <td>
                    <b>Author Quality:</b>
                    <br>
                    <star-rating 
                        read-only
                        v-model="userStats.authorQuality"
                        :show-rating="false"
                        :max-rating="5" 
                        :increment="0.1"
                        :star-size="18" 
                        style="display: inline-block">
                    </star-rating>
                    <br>
                    {{userStats.authorQuality.toFixed(1)}}
                </td>
                <td>
                    <b>Author Difficulty:</b>
                    <br>
                    <star-rating 
                        read-only
                        v-model="userStats.authorDifficulty"
                        :show-rating="false"
                        :max-rating="3" 
                        :increment="0.1"
                        :star-size="18" 
                        style="display: inline-block">
                    </star-rating>
                    <br>
                    {{userStats.authorDifficulty.toFixed(1)}}
                </td>
            </tr>
        </table>
        <br><br>
        <h2>User Cases</h2>
        <CaseList :userProfile="publicID"/>
        <br><br>
    </md-card>
</template>

<script>
    import StarRating from 'vue-star-rating'
    import APIRequests from "./APIRequests.js"
    import CaseList from "./CaseList.vue"
    
    export default {
        components: {
            StarRating,
            CaseList
        },
        props: {
            publicID: {
                type: String
            }
        },
        data: function(){
            return {
                userStats: {},
            }
        },
        methods: {
            fetchUserStats: function(){
                var api_url = this.$store.state.api_url + "/api/users/userStats/" + this.publicID
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    this.userStats = data
                }).catch((xhrResponse) => {
                    if(xhrResponse[0] != 200){
                        this.$router.replace("/")
                    }
                })
            },
        },
        mounted: function () {
            this.$nextTick(function () {
                this.fetchUserStats()
            })
        }
    }
</script>

<style>
    table{
        overflow: scroll;
        width: 100%;
        text-align: center;
    }
    td{
        border-bottom: 1px dotted black;
        padding: 7px;
    }
</style>